/* Auto-discount display: shows synced automatic discounts only inside their start/end window (browser clock),
   with the discounted price, a countdown on product pages, and a "tonight" teaser up to 12h before start. */
(function () {
  var TEASE_MS = 12 * 3600 * 1000;
  function fmt(cents, el) {
    var f = (el.getAttribute('data-money-format') || '{{amount}} AED').replace(/<[^>]*>/g, '').replace(/&lt;[^&]*&gt;/g, '');
    var v = (Math.max(0, cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  }
  function newPrice(el) {
    var p = parseInt(el.getAttribute('data-price'), 10) || 0, k = el.getAttribute('data-k'), v = parseFloat(el.getAttribute('data-v')) || 0;
    if (k === 'pct') return Math.round(p * (1 - v));
    if (k === 'amt') return p - Math.round(v * 100);
    return p;
  }
  function two(n) { return (n < 10 ? '0' : '') + n; }
  function dur(ms) { var s = Math.max(0, Math.floor(ms / 1000)), h = Math.floor(s / 3600); return two(h) + ':' + two(Math.floor(s % 3600 / 60)) + ':' + two(s % 60); }
  function clock(ts) { try { return new Date(ts).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }); } catch (e) { return ''; } }
  function q(el, sel) { return el.querySelector(sel); }
  function update() {
    var now = Date.now();
    document.querySelectorAll('[data-adisc]').forEach(function (el) {
      var s = (parseInt(el.getAttribute('data-s'), 10) || 0) * 1000, e = (parseInt(el.getAttribute('data-e'), 10) || 0) * 1000;
      var live = now >= s && (!e || now < e), soon = !live && now < s && s - now <= TEASE_MS;
      var card = el.hasAttribute('data-card'), k = el.getAttribute('data-k');
      var show = live || (soon && !card && k !== 'bxgy');
      el.hidden = !show; el.classList.toggle('is-soon', soon);
      if (!show) return;
      if (k === 'bxgy') { var bt = q(el, '[data-adisc-timer]'); if (bt && e) bt.textContent = dur(e - now); return; }
      var np = q(el, '[data-adisc-new]'); if (np) np.textContent = fmt(newPrice(el), el);
      var nl = q(el, '[data-adisc-note-live]'), ns = q(el, '[data-adisc-note-soon]');
      if (nl) nl.hidden = soon; if (ns) ns.hidden = !soon;
      var st = q(el, '[data-adisc-start]'); if (st) st.textContent = clock(s);
      var lead = q(el, '[data-adisc-lead]'); if (lead && !card) lead.textContent = soon ? (el.getAttribute('data-lead-soon') || lead.getAttribute('data-soon') || lead.textContent) : (lead.getAttribute('data-live') || lead.textContent);
      var tw = q(el, '[data-adisc-timer-wrap]'), tv = q(el, '[data-adisc-timer]'), tl = q(el, '[data-adisc-timer-label]');
      if (tw) {
        var target = soon ? s : e;
        tw.hidden = !target;
        if (tv && target) tv.textContent = dur(target - now);
        if (tl) tl.textContent = soon ? (tl.getAttribute('data-soon') || tl.textContent) : (tl.getAttribute('data-live') || tl.textContent);
      }
    });
  }
  document.addEventListener('variant:change', function (ev) {
    var v = ev.detail && ev.detail.variant; if (!v) return;
    var root = ev.target && ev.target.closest ? ev.target.closest('[data-product]') || ev.target : document;
    root.querySelectorAll('[data-adisc][data-price]').forEach(function (el) { el.setAttribute('data-price', v.price); });
    update();
  });
  /* Refresh the buy-X-get-Y box (cart progress) after any cart change, by re-rendering its section with the new cart. */
  var refreshT;
  function refreshOffers() {
    clearTimeout(refreshT);
    refreshT = setTimeout(function () {
      var boxes = document.querySelectorAll('.adisc-offer');
      var done = {};
      boxes.forEach(function (box) {
        var sec = box.closest('[id^="shopify-section-"]'); if (!sec) return;
        var id = sec.id.replace('shopify-section-', ''); if (done[id]) return; done[id] = true;
        var url = window.location.pathname + (window.location.search ? window.location.search + '&' : '?') + 'section_id=' + encodeURIComponent(id);
        fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : null; }).then(function (html) {
          if (!html) return;
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelectorAll('.adisc-offer');
          sec.querySelectorAll('.adisc-offer').forEach(function (old, i) { if (fresh[i]) old.innerHTML = fresh[i].innerHTML; });
          update();
        }).catch(function () {});
      });
    }, 250);
  }
  document.addEventListener('cart:updated', refreshOffers);
  document.addEventListener('cart:rendered', refreshOffers);

  function start() { update(); setInterval(update, 1000); if (window.MutationObserver) { var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(update, 50); }).observe(document.body, { childList: true, subtree: true }); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
